/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { call, put, takeLatest, select } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { HomeConstants } from '../../home/store/home.constants'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { getVersion, processVersionUpgrade } from '../../../utilities/version.util'
import { upgradeStatus } from '../store/home.types'
import { onSelectPCR, setIsPCROpening, setUpgradeStatus } from '../store/home.actions'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import Logger from '../../../services/logger.service'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { buildPcrSummary } from '../../../utilities/pcr.util'

export function* upgradePCR() {
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocumentId: string = yield select(getPcrIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrDocumentId)
  if (!pcrDocumentId) {
    // todo: add to audit log
    yield put(setIsPCROpening(false))
    return
  }
  try {
    if (!pcrDoc.version) {
      pcrDoc['version'] = '0.0'
    }
    const clientVersion: string = getVersion()
    if (!clientVersion || clientVersion == null || clientVersion === '' || clientVersion === 'null') {
      Logger.error(`No Client version found. Unable to upgrade PCR: ${pcrDocumentId}.`)
      yield put(setIsPCROpening(false))
      return
    }
    if (pcrDoc.version === clientVersion) {
      yield put(setUpgradeStatus(upgradeStatus.COMPLETE))
      yield put(onSelectPCR(buildPcrSummary(pcrDoc)))
      return
    }
    yield put(setUpgradeStatus(upgradeStatus.IN_PROGRESS))

    processVersionUpgrade(pcrDoc, clientVersion)

    if (pcrDoc.version === clientVersion) {
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDoc)
      yield put(setUpgradeStatus(upgradeStatus.COMPLETE))
      yield put(onSelectPCR(buildPcrSummary(pcrDoc)))
    } else {
      yield put(setUpgradeStatus(upgradeStatus.FAILED))
    }
  } catch (e) {
    yield put(setIsPCROpening(false))
    yield put(setUpgradeStatus(upgradeStatus.FAILED))
    yield put(throwPcrException(`upgradePCR() error: ${e}`))
  }
}

export function* upgradePCRSaga() {
  yield takeLatest([HomeConstants.UPGRADE_PCR], performWithMutexHOG, upgradePCR)
}
